import React from 'react';
import { BOOKING_LIMIT_MESSAGE } from '../../utils/bookingLimits';
import '../../styles/BookingLimitBanner.css';

function BookingLimitBanner({ message, dailyActionsUsed, dailyLimit }) {
  return (
    <div className="booking-limit-banner" role="alert">
      <h3 className="booking-limit-banner-title">تم الوصول للحد اليومي للحجوزات</h3>
      <p className="booking-limit-banner-text">{message || BOOKING_LIMIT_MESSAGE}</p>
      {typeof dailyActionsUsed === 'number' && typeof dailyLimit === 'number' && (
        <p className="booking-limit-banner-meta">
          العمليات اليوم: {dailyActionsUsed} / {dailyLimit}
        </p>
      )}
    </div>
  );
}

export default BookingLimitBanner;
